import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { CustodianApiService } from './custodian.service';
import {
  loadCustodianList,
  loadCustodianListSuccess,
  loadCustodianListFailure,
} from './custodian.actions';

@Injectable()
export class CustodianEffects {
  private actions$ = inject(Actions);
  private custodianService = inject(CustodianApiService);

  loadCustodianList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCustodianList),
      mergeMap(() =>
        this.custodianService.getCustodianList().pipe(
          map((response: any) => {
            if (response.status === 'Failed') {
              return loadCustodianListFailure({ error: response.message });
            }
            return loadCustodianListSuccess({ data: response.data });
          }),
          catchError((error) => of(loadCustodianListFailure({ error })))
        )
      )
    )
  );
}
